async function checkUserSignedIn() {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/auth/check`;

  try {
    const response = await fetch(url, { credentials: "include" });
    const result = await response.json();

    if (result.error) return null;
    return result;
  } catch (err) {
    return null;
  }
}

export default checkUserSignedIn;
